import { createAsyncThunk } from "@reduxjs/toolkit";
import { mapPlanChecks } from "../Types/PlanCheck/PlanCheckType";
import { getPlanCheckByFolderId, getPlanCheckReference } from "../../Api/PlanCheck/PlanCheckApiServices";
import { mapPlanCheckReference } from "../Types/PlanCheck/PlanCheckReference";

// get all plan check list
export const getAllPlanChckList = createAsyncThunk('getAllPlanChckList', async (folder_id: number, { rejectWithValue }) => {
  try {
    // api
    const response = await getPlanCheckByFolderId(folder_id);
    if (response.status) {
      return mapPlanChecks(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all plan check list');
  }
});

// fetch plan check reference list
export const fetchPlanCheckReference = createAsyncThunk('fetchPlanCheckReference', async (_, { rejectWithValue }) => {
  try {
    // api
    const response = await getPlanCheckReference();
    if (response.status) {
      return mapPlanCheckReference(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch plan check reference list');
  }
});
